var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIncentive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.05627 18.209H1.59306C1.21604 18.209 0.910156 18.5149 0.910156 18.8919V26.1762C0.910156 26.5532 1.21604 26.8591 1.59306 26.8591H7.05627C7.43329 26.8591 7.73917 26.5532 7.73917 26.1762V18.8919C7.73917 18.5149 7.43329 18.209 7.05627 18.209Z",
    fill: "url(#paint0_linear_740_6191)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1578 14.5684H10.6946C10.3176 14.5684 10.0117 14.8742 10.0117 15.2513V26.1777C10.0117 26.5547 10.3176 26.8606 10.6946 26.8606H16.1578C16.5349 26.8606 16.8407 26.5547 16.8407 26.1777V15.2513C16.8407 14.8742 16.5349 14.5684 16.1578 14.5684Z",
    fill: "url(#paint1_linear_740_6191)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2711 10.9277H19.8079C19.4309 10.9277 19.125 11.2336 19.125 11.6106V26.1792C19.125 26.5562 19.4309 26.8621 19.8079 26.8621H25.2711C25.6481 26.8621 25.954 26.5562 25.954 26.1792V11.6106C25.954 11.2336 25.6481 10.9277 25.2711 10.9277Z",
    fill: "url(#paint2_linear_740_6191)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8199 3.23756C26.675 2.80274 26.2944 2.52264 25.8489 2.52264H24.0945L23.529 0.731798C23.3903 0.294322 22.9982 0 22.5518 0C22.1054 0 21.7133 0.294322 21.5754 0.731807L21.009 2.52265H19.2546C18.8092 2.52265 18.4286 2.80275 18.2836 3.23756C18.1351 3.68216 18.2828 4.16678 18.6527 4.44332L20.0683 5.50057L19.5134 7.25583C19.3702 7.70753 19.5285 8.19214 19.9073 8.46156C20.2654 8.7163 20.7412 8.70875 21.0926 8.44647L22.5518 7.35631L24.0109 8.44647C24.3693 8.71412 24.8343 8.71856 25.1962 8.46158C25.5751 8.19215 25.7333 7.70755 25.5902 7.25761L25.0353 5.50056L26.4518 4.44331C26.8208 4.16677 26.9684 3.68216 26.8199 3.23756Z",
    fill: "url(#paint3_linear_740_6191)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.32505 15.9352C6.7137 15.9352 8.65009 13.9989 8.65009 11.6102C8.65009 9.22154 6.7137 7.28516 4.32505 7.28516C1.93639 7.28516 0 9.22154 0 11.6102C0 13.9989 1.93639 15.9352 4.32505 15.9352Z",
    fill: "url(#paint4_linear_740_6191)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7267 5.58316C16.7267 5.58316 14.3257 4.68981 14.313 4.68509C13.4966 4.38133 13.0055 5.65615 13.8364 5.96551L14.7059 6.28902C14.7059 6.28902 10.4252 8.24757 10.4086 8.25517C9.61428 8.61859 10.1703 9.87052 10.9767 9.49651L15.2729 7.53122C15.2729 7.53122 14.9518 8.39471 14.9501 8.39923C14.6458 9.21747 15.9216 9.70583 16.2305 8.87586L17.1286 6.46169C17.2602 6.10778 17.0797 5.71476 16.7267 5.58316Z",
    fill: "url(#paint5_linear_740_6191)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_740_6191",
    x1: 2.49017,
    y1: 23.0997,
    x2: 7.6901,
    y2: 23.0987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_740_6191",
    x1: 11.5917,
    y1: 21.5183,
    x2: 16.7917,
    y2: 21.5176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_740_6191",
    x1: 20.705,
    y1: 19.9369,
    x2: 25.9049,
    y2: 19.9363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_740_6191",
    x1: 20.228,
    y1: 4.89109,
    x2: 26.8148,
    y2: 4.88951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_740_6191",
    x1: 2.00135,
    y1: 12.1758,
    x2: 8.58793,
    y2: 12.1743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_740_6191",
    x1: 11.6773,
    y1: 7.42424,
    x2: 17.1203,
    y2: 7.42235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncentive);
export default __webpack_public_path__ + "static/media/incentive.fa5a48cb7626894e4abe31c9f9d7c18d.svg";
export { ForwardRef as ReactComponent };